import { QIcon, QStack, QText } from '@qualio/ui-components';
import { Tag } from '../../../api/model/tag';

type TagLabelProps = {
  tag: Tag;
};

export const TagLabel = ({ tag }: TagLabelProps) => {
  return (
    <QStack direction="row">
      <QText
        title={tag.name}
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
        marginY="auto"
        maxWidth="245px"
      >
        {tag.name}
        {tag.group_ids.length > 0 && (
          <>
            &nbsp;
            <QIcon iconName="Lock" size="xs" />
          </>
        )}
      </QText>
    </QStack>
  );
};
